// Maps signup source to admin buckets: web (no UserLogin), ios, android.
// Mobile apps send deviceType "iOS" / "android"; web signup passes nothing.

// SQL mirror of normalizeSignupDeviceCategory — column must be signup_device.deviceType.
export const SIGNUP_DEVICE_CATEGORY_SQL = `
  CASE
    WHEN signup_device.deviceType IS NULL OR TRIM(signup_device.deviceType) = '' THEN 'web'
    WHEN LOWER(signup_device.deviceType) LIKE '%ios%' THEN 'ios'
    WHEN LOWER(signup_device.deviceType) LIKE '%android%' THEN 'android'
    ELSE 'web'
  END
`;

export function normalizeSignupDeviceCategory(deviceType) {
  if (!deviceType || typeof deviceType !== 'string' || !deviceType.trim()) {
    return 'web';
  }
  const lower = deviceType.toLowerCase();
  if (lower.includes('ios')) {
    return 'ios';
  }
  if (lower.includes('android')) {
    return 'android';
  }
  return 'web';
}

export const ALLOWED_DEVICE_FILTERS = ['web', 'ios', 'android'];

export default normalizeSignupDeviceCategory;
